import { IAuthenticationProvider, AuthEnvironment } from "../../interfaces/IAuthenticationProvider";
import { AuthSharedComponent } from "./AuthSharedComponent";
import { AuthErrors, AuthError } from './AuthErrors';
import { IS_DEV_BUILD } from '../../../AppConstants';

declare const OfficeFirstPartyAuth: any;

/*
    Prod stands for "Production environment". 
    It also includes the dogfood environment (i.e string "-df" may be appended somewhere on their URL)
     
    For ex: www.office.com, microsoft.sharepoint.com, microsoft.sharepoint-df.com etc
*/
export class ProdAuthenticationProvider implements IAuthenticationProvider {
    private authSharedComponent: AuthSharedComponent = new AuthSharedComponent();

    Authenticate(): void {
        // Workaround for ICE bug https://office.visualstudio.com/OC/_workitems/edit/4132146
        if (IS_DEV_BUILD) {
            OfficeFirstPartyAuth.debugging = true;
            OfficeFirstPartyAuth.authorityOverride = "https://login.microsoftonline.com/";
        }

        try {
            this.authSharedComponent.Authenticate();
        } catch (error) {
            throw new AuthError(AuthErrors.UnableToAuthenticate, error.message);
        }
    }

    async GetAccessToken(resource: string): Promise<string> {
        try {
            return await this.authSharedComponent.GetAccessToken(resource);
        } catch (error) {
            if (error.code == "popup_window_error") {
                throw new AuthError(AuthErrors.PopupWindowError, error.message);
            } else {
                throw new AuthError(AuthErrors.UnableToFetchToken, error.message);
            }
        }
    }

    GetAuthEnvironment(): AuthEnvironment {
        return AuthEnvironment.Prod;
    }
}